import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { GuidService } from '../services/guid.service'; // Importe o serviço

export const guidInterceptor: HttpInterceptorFn = (req, next) => {
  const guidService = inject(GuidService); // Usamos 'inject' para pegar o serviço
  const clientGuid = guidService.getGuid();

  const modifiedReq = clientGuid 
    ? req.clone({ setHeaders: { 'X-Client-GUID': clientGuid } })
    : req;

  return next(modifiedReq);
};
